import { render } from "./GrapesJS.vue?vue&type=template&id=f04f29c4"
import script from "./GrapesJS.vue?vue&type=script&lang=js"
export * from "./GrapesJS.vue?vue&type=script&lang=js"

import "./GrapesJS.vue?vue&type=style&index=0&id=f04f29c4&lang=css"
script.render = render

export default script